import React from "react";
import PropTypes from "prop-types";

function TickRenderer({ tick }) {
  return tick.helpText ? (
    <div
      data-tooltip={tick.helpText}
      data-tooltip-class="genome-browser-small-tooltip"
      className="tw-text-3xs tw-opacity-80"
    >
      {tick.label}
    </div>
  ) : (
    <div className="tw-font-bold">{tick.label}</div>
  );
}

TickRenderer.propTypes = {
  tick: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    helpText: PropTypes.string,
  }).isRequired,
};

export default TickRenderer;
